import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_INSTITUTIONPROCEDURES_LOAD_BY_INSTITUTION_ID,
    ACTION_INSTITUTIONPROCEDURE_LOAD_BY_ID,

    ACTION_INSTITUTIONPROCEDURE_SAVE,

    ACTION_INSTITUTIONPROCEDURE_CREATE,

    ACTION_INSTITUTIONPROCEDURE_VALIDATE,

    IInstitutionProceduresLoadByInstitutionIdAction,
    IInstitutionProcedureLoadByIdAction,
    IInstitutionProcedureLoadFailureAction,
    IInstitutionProcedureLoadSuccessAction,

    IInstitutionProcedureSaveAction,
    IInstitutionProcedureSaveSuccessAction,
    IInstitutionProcedureSaveFailureAction,

    IInstitutionProcedureCreateAction,
    IInstitutionProcedureCreateSuccessAction,
    IInstitutionProcedureCreateFailureAction,

    IInstitutionProcedureValidateAction,
    IInstitutionProcedureValidateSuccessAction,
    IInstitutionProcedureValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/institutionProcedure";
import { institutionProcedureApi } from "../services/institutionProcedure";

export const
    getInstitutionProceduresByInstitutionIdEpic = (action$): Observable<IInstitutionProcedureLoadSuccessAction | IInstitutionProcedureLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONPROCEDURES_LOAD_BY_INSTITUTION_ID)
            .mergeMap((action: IInstitutionProceduresLoadByInstitutionIdAction) => {
                return institutionProcedureApi
                    .getInstitutionProceduresByInstitutionId(action.institutionId)
                    .map(response =>
                        LoadSuccess(response.institutionProcedures, null, null, null, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionProcedureByIdEpic = (action$): Observable<IInstitutionProcedureLoadSuccessAction | IInstitutionProcedureLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONPROCEDURE_LOAD_BY_ID)
            .mergeMap((action: IInstitutionProcedureLoadByIdAction) => {
                return institutionProcedureApi
                    .getInstitutionProcedureById(action.id)
                    .map(response =>
                        LoadSuccess(response.institutionProcedure, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInstitutionProcedureEpic = (action$): Observable<IInstitutionProcedureSaveSuccessAction | IInstitutionProcedureSaveFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONPROCEDURE_SAVE)
            .mergeMap((action: IInstitutionProcedureSaveAction) => {
                return institutionProcedureApi
                    .setInstitutionProcedure(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.institutionProcedure, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInstitutionProcedureEpic = (action$): Observable<IInstitutionProcedureCreateSuccessAction | IInstitutionProcedureCreateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONPROCEDURE_CREATE)
            .mergeMap((action: IInstitutionProcedureCreateAction) => {
                return institutionProcedureApi
                    .createInstitutionProcedure(action.institutionId)
                    .map(response =>
                        CreateSuccess(
                            response.institutionProcedure,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateInstitutionProcedureEpic = (action$): Observable<IInstitutionProcedureValidateSuccessAction | IInstitutionProcedureValidateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONPROCEDURE_VALIDATE)
            .mergeMap((action: IInstitutionProcedureValidateAction) => {
                return institutionProcedureApi
                    .validateInstitutionProcedure(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.institutionProcedure, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }